import apiClient from '@/services/axios';
import ReconnectingEventSource from 'reconnecting-eventsource';

let eventSource: ReconnectingEventSource | null = null;
let eventHandler: ((data: any) => void) | null = null;

let retryCount = 0;
// const MAX_RETRIES = 5;
let isUnsubscribed = false;
// let renewalTimeout: ReturnType<typeof setTimeout> | null = null;

export const subscribeToMercure = async (
  userIdentifier: string,
  onMessage?: (data: any) => void,
  onError?: (err: unknown) => void
): Promise<() => void> => {
  if (!userIdentifier) {
    return () => {  console.log('Unsubscribed');  };
  }

  // unsubscribeFromMercure();
  if (eventSource) {
  unsubscribeFromMercure();
  }

  eventHandler = onMessage || null;
  isUnsubscribed = false;
  retryCount = 0;

  try {
    const res = await apiClient.post('/mercure/subscribe', {
      topics: [`/users/${userIdentifier}/devices`],
    });

    const token = res.data.token;
    const topic = encodeURIComponent(res.data.topics[0]);

    const mercureUrl = process.env.VUE_APP_MERCURE_URL;
    const url = `${mercureUrl}/.well-known/mercure?topic=${topic}&authorization=${token}`;

    // const topic = `/users/${userIdentifier}/devices`;
    // const sseUrl = 'http://localhost:3000';

    // const url = `${sseUrl}?topic=${encodeURIComponent(topic)}`;

    // const eventSource = new EventSource(url);

    // const topic = `/users/${userIdentifier}/devices`;
    // const mercureUrl = 'http://localhost:3000';    
    // const url = `${mercureUrl}?topic=${encodeURIComponent(topic)}`;

    if (typeof window !== 'undefined') {
      (window as any).__mercureLogs__ = (window as any).__mercureLogs__ || [];
      (window as any).__mercureLogs__.push(`Mercure URL: ${mercureUrl}`);
      (window as any).__mercureLogs__.push(`Mercure full URL (token redacted): ${mercureUrl}/.well-known/mercure?topic=${topic}&authorization=[REDACTED]`);
      (window as any).__mercureDebug__ = { mercureUrl, topic, timestamp: Date.now() };
    }

    eventSource = new ReconnectingEventSource(url, {
      withCredentials: true,
      max_retry_time: 5000,
      eventSourceClass: EventSource,
    });

  
    const timeout = setTimeout(() => {
      if (eventSource?.readyState !== EventSource.OPEN) {
        const readyState = eventSource?.readyState;
        console.error('Mercure connection timeout', { readyState });
        if (typeof window !== 'undefined') {
          (window as any).__mercureLogs__ = (window as any).__mercureLogs__ || [];
          (window as any).__mercureLogs__.push(`Mercure connection timeout (readyState: ${readyState})`);
        }
        unsubscribeFromMercure();
        onError?.(new Error('Mercure connection timeout'));
      }
    }, 5000);

    eventSource.onopen = () => {
      console.log('Mercure connected');
      if (typeof window !== 'undefined') {
        (window as any).__mercureConnected__ = true;
        (window as any).__mercureLogs__ = (window as any).__mercureLogs__ || [];
        (window as any).__mercureLogs__.push('Mercure connected');
      }
      clearTimeout(timeout);
      retryCount = 0;

      
      // if (renewalTimeout) clearTimeout(renewalTimeout);
      // renewalTimeout = setTimeout(() => {
      //   console.log('Refreshing Mercure token...');
      //   subscribeToMercure(userIdentifier, onMessage, onError);
      // }, 29 * 60 * 1000); //Refresh token before expiry (29 min)
    };

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (typeof window !== 'undefined') {
          (window as any).__mercureLogs__ = (window as any).__mercureLogs__ || [];
          (window as any).__mercureLogs__.push(`Mercure event received: ${JSON.stringify(data)}`);
        }
        eventHandler?.(data);
      } catch (err) {
        console.error('Failed to parse Mercure event:', err);
      }
    };

    eventSource.onerror = async (err: any) => {
      if (isUnsubscribed) return;
      const readyState = eventSource?.readyState;
      console.error('Mercure error:', err, { readyState });
      if (typeof window !== 'undefined') {
        (window as any).__mercureConnected__ = false;
        (window as any).__mercureLogs__ = (window as any).__mercureLogs__ || [];
        (window as any).__mercureLogs__.push(`Mercure onerror (readyState: ${readyState}, type: ${err?.type}, status: ${err?.status})`);
      }
      if (eventSource?.readyState === EventSource.CLOSED) {
        console.error('Mercure connection closed. Attempting to reconnect...');
        if (typeof window !== 'undefined') {
          (window as any).__mercureLogs__.push('Mercure connection closed — attempting reconnect');
        }
        unsubscribeFromMercure();
        await subscribeToMercure(userIdentifier, onMessage, onError);
      }
    };
  } catch (err) {
    console.error('Mercure subscribe failed:', err);
    onError?.(err);
  }

  return unsubscribeFromMercure;
};

export const unsubscribeFromMercure = () => {
  // isUnsubscribed = true;

  if (eventSource) {
    eventSource.close();
    eventSource = null;
  }

  // if (renewalTimeout) {
  //   clearTimeout(renewalTimeout);
  //   renewalTimeout = null;
  // }

  eventHandler = null;
  retryCount = 0;

  console.log('Unsubscribed from Mercure');
};
